import { render, staticRenderFns } from "./TambahKonsumen.vue?vue&type=template&id=5106959d"
import script from "./TambahKonsumen.vue?vue&type=script&lang=js"
export * from "./TambahKonsumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports